import { render, staticRenderFns } from "./TradeView.vue?vue&type=template&id=34355ae9&scoped=true"
import script from "./TradeView.vue?vue&type=script&lang=ts"
export * from "./TradeView.vue?vue&type=script&lang=ts"
import style0 from "./TradeView.vue?vue&type=style&index=0&id=34355ae9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34355ae9",
  null
  
)

export default component.exports